// src/components/Contact.js
import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaClock, FaFacebookF, FaInstagram, FaTwitter, FaYoutube } from "react-icons/fa";

const ContactSection = styled.section`
  background-color: #0a0a0a;
  id: "contact";
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const ContactContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 50px;
  
  @media (max-width: 992px) {
    grid-template-columns: 1fr;
  }
`;

const ContactInfo = styled.div`
  @media (max-width: 992px) {
    order: 2;
  }
`;

const InfoTitle = styled.h3`
  font-size: 24px;
  margin-bottom: 30px;
  font-family: 'Orbitron', sans-serif;
  color: #ff9900;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

const InfoList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const InfoItem = styled.li`
  display: flex;
  margin-bottom: 25px;
`;

const InfoIcon = styled.div`
  width: 50px;
  height: 50px;
  background: rgba(255, 153, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin-right: 15px;
  color: #ff9900;
  font-size: 20px;
  flex-shrink: 0;
`;

const InfoContent = styled.div``;

const InfoLabel = styled.h4`
  font-size: 18px;
  margin-bottom: 5px;
  color: #fff;
`;

const InfoText = styled.p`
  font-size: 16px;
  color: #ccc;
  line-height: 1.5;
`;

const SocialLinks = styled.div`
  display: flex;
  margin-top: 30px;
  gap: 15px;
`;

const SocialLink = styled(motion.a)`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-radius: 50%;
  transition: all 0.3s ease;
  
  &:hover {
    background: #ff9900;
    color: #000;
  }
`;

const ContactForm = styled.div`
  background: rgba(30, 30, 30, 0.5);
  padding: 40px;
  border-radius: 20px;
  backdrop-filter: blur(10px);
  
  @media (max-width: 992px) {
    order: 1;
  }
  
  @media (max-width: 576px) {
    padding: 30px 20px;
  }
`;

const FormTitle = styled.h3`
  font-size: 24px;
  margin-bottom: 30px;
  font-family: 'Orbitron', sans-serif;
  color: #ff9900;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

const Form = styled.form``;

const FormGroup = styled.div`
  margin-bottom: 20px;
`;

const Input = styled.input`
  width: 100%;
  padding: 15px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  color: #fff;
  font-size: 16px;
  transition: all 0.3s ease;
  
  &:focus {
    border-color: #ff9900;
    outline: none;
    box-shadow: 0 0 5px rgba(255, 153, 0, 0.5);
  }
  
  &::placeholder {
    color: rgba(255, 255, 255, 0.5);
  }
`;

const TextArea = styled.textarea`
  width: 100%;
  padding: 15px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  color: #fff;
  font-size: 16px;
  resize: vertical;
  min-height: 150px;
  transition: all 0.3s ease;
  
  &:focus {
    border-color: #ff9900;
    outline: none;
    box-shadow: 0 0 5px rgba(255, 153, 0, 0.5);
  }
  
  &::placeholder {
    color: rgba(255, 255, 255, 0.5);
  }
`;

const SubmitButton = styled(motion.button)`
  background: linear-gradient(45deg, #ff9900, #ff6600);
  color: #000;
  border: none;
  padding: 15px 30px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 10px;
  cursor: pointer;
  font-family: 'Orbitron', sans-serif;
  text-transform: uppercase;
  letter-spacing: 1px;
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 5px 15px rgba(255, 153, 0, 0.5);
  }
`;

const MapContainer = styled.div`
  margin-top: 50px;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
`;

const Map = styled.iframe`
  width: 100%;
  height: 400px;
  border: none;
`;

const Contact = () => {
  return (
    <ContactSection id="contact">
      <Container>
        <h2 className="section-title" data-aos="fade-up">Contact Us</h2>
        
        <ContactContainer>
          <ContactInfo data-aos="fade-right">
            <InfoTitle>Get In Touch</InfoTitle>
            <InfoList>
              <InfoItem>
                <InfoIcon>
                  <FaMapMarkerAlt />
                </InfoIcon>
                <InfoContent>
                  <InfoLabel>Our Location</InfoLabel>
                  <InfoText>Opposite Vence Paradise, Danapur, Patna, Bihar, India</InfoText>
                </InfoContent>
              </InfoItem>
              
              <InfoItem>
                <InfoIcon>
                  <FaPhoneAlt />
                </InfoIcon>
                <InfoContent>
                  <InfoLabel>Phone Number</InfoLabel>
                  <InfoText>+91 96725 65772</InfoText>
                </InfoContent>
              </InfoItem>
              
              <InfoItem>
                <InfoIcon>
                  <FaEnvelope />
                </InfoIcon>
                <InfoContent>
                  <InfoLabel>Email Address</InfoLabel>
                  <InfoText>hopito.in@gmail.com</InfoText>
                </InfoContent>
              </InfoItem>
              
              <InfoItem>
                <InfoIcon>
                  <FaClock />
                </InfoIcon>
                <InfoContent>
                  <InfoLabel>Opening Hours</InfoLabel>
                  <InfoText>Monday - Sunday: 10:00 AM - 10:00 PM</InfoText>
                </InfoContent>
              </InfoItem>
            </InfoList>
            
            <SocialLinks>
              <SocialLink 
                href="#" 
                whileHover={{ scale: 1.2 }}
                whileTap={{ scale: 0.9 }}
              >
                <FaFacebookF />
              </SocialLink>
              <SocialLink 
                href="#" 
                whileHover={{ scale: 1.2 }}
                whileTap={{ scale: 0.9 }}
              >
                <FaInstagram />
              </SocialLink>
              <SocialLink 
                href="#" 
                whileHover={{ scale: 1.2 }}
                whileTap={{ scale: 0.9 }}
              >
                <FaTwitter />
              </SocialLink>
              <SocialLink 
                href="#" 
                whileHover={{ scale: 1.2 }}
                whileTap={{ scale: 0.9 }}
              >
                <FaYoutube />
              </SocialLink>
            </SocialLinks>
          </ContactInfo>
          
          <ContactForm data-aos="fade-left">
            <FormTitle>Send Message</FormTitle>
            <Form>
              <FormGroup>
                <Input type="text" placeholder="Your Name" />
              </FormGroup>
              <FormGroup>
                <Input type="email" placeholder="Your Email" />
              </FormGroup>
              <FormGroup>
                <Input type="text" placeholder="Subject" />
              </FormGroup>
              <FormGroup>
                <TextArea placeholder="Your Message" />
              </FormGroup>
              <SubmitButton 
                type="submit"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Send Message
              </SubmitButton>
            </Form>
          </ContactForm>
        </ContactContainer>
        
        <MapContainer data-aos="zoom-in">
          <Map 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4427.419043755168!2d85.03076347606341!3d25.59971771527843!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39ed57ed9fd029df%3A0xb2274ea025cdf940!2sVenus%20Paradise!5e1!3m2!1sen!2sin!4v1744186590748!5m2!1sen!2sin"
            allowFullScreen="" 
            loading="lazy" 
            referrerPolicy="no-referrer-when-downgrade"
          />
        </MapContainer>
      </Container>
    </ContactSection>
  );
};

export default Contact;